import type * as React from "react";

import { Card } from "./card";
import { cn } from "../lib/utils";

export function Eyebrow({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn("text-xs font-semibold uppercase tracking-[0.13em] text-muted-foreground", className)} {...props} />;
}

export function PageHeader({
  eyebrow,
  title,
  actions,
}: {
  eyebrow?: string;
  title: string;
  actions?: React.ReactNode;
}) {
  return (
    <header className="page-header grid gap-5">
      <div className="space-y-1">
        {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
        <h1 className="font-brand text-3xl font-semibold tracking-[-0.045em] sm:text-4xl xl:text-[2.75rem]">{title}</h1>
      </div>
      {actions ? <div className="page-header-actions">{actions}</div> : null}
    </header>
  );
}

export function MetricCard({
  label,
  value,
  detail,
  primary = false,
  unavailable = false,
}: {
  label: string;
  value: React.ReactNode;
  detail?: React.ReactNode;
  primary?: boolean;
  unavailable?: boolean;
}) {
  return (
    <Card className={cn(
      "flex min-h-28 flex-col justify-between gap-3 p-4 sm:min-h-36 sm:p-5",
      primary && "border-primary bg-primary text-primary-foreground",
      unavailable && "bg-muted text-muted-foreground",
    )}>
      <span className={cn("text-sm font-semibold text-muted-foreground", primary && "text-primary-foreground/70")}>{label}</span>
      <strong className="font-brand text-2xl font-semibold tracking-[-0.05em] sm:text-4xl">{value}</strong>
      {detail ? <small className={cn("text-muted-foreground", primary && "text-primary-foreground/70")}>{detail}</small> : null}
    </Card>
  );
}

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex min-h-32 flex-col items-center justify-center gap-2 rounded-lg border border-dashed p-6 text-center">
      <h3 className="font-brand font-semibold">{title}</h3>
      {description ? <p className="max-w-xl text-sm text-muted-foreground">{description}</p> : null}
      {action}
    </div>
  );
}

export function LoadingState({ label = "Loading…" }: { label?: string }) {
  return <div className="flex min-h-32 items-center justify-center text-sm text-muted-foreground" role="status">{label}</div>;
}
